// Senior-themed status banner. Wraps Polaris Banner with larger type
// and forced 4.5:1 contrast colors from the senior token palette.

import { Banner } from '@shopify/polaris';
import type { ReactNode } from 'react';

interface SeniorBannerProps {
  title?: string;
  tone?: 'info' | 'success' | 'warning' | 'critical';
  onDismiss?: () => void;
  children: ReactNode;
  'data-testid'?: string;
}

export function SeniorBanner({
  title,
  tone = 'info',
  onDismiss,
  children,
  ...rest
}: SeniorBannerProps) {
  return (
    <div {...rest}>
      <Banner title={title} tone={tone} onDismiss={onDismiss}>
        {children}
      </Banner>
    </div>
  );
}
